module.exports = __webpack_public_path__ + "9.dd62c28f.png";